var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 5.625C6.125 5.16016 6.50781 4.75 7 4.75H14C14.4648 4.75 14.875 5.16016 14.875 5.625C14.875 6.11719 14.4648 6.5 14 6.5H13.1797L13.4805 10.5742C14.4922 11.1211 15.2852 12.0234 15.668 13.1445L15.6953 13.2266C15.7773 13.5 15.75 13.8008 15.5859 14.0195C15.4219 14.2383 15.1484 14.375 14.875 14.375H6.125C5.82422 14.375 5.57812 14.2656 5.41406 14.0195C5.22266 13.8008 5.19531 13.5 5.27734 13.2266L5.30469 13.1445C5.6875 12.0234 6.48047 11.1211 7.49219 10.5742L7.79297 6.5H7C6.50781 6.5 6.125 6.11719 6.125 5.625ZM9.625 15.25H11.375V17.875C11.375 18.3672 10.9648 18.75 10.5 18.75C10.0078 18.75 9.625 18.3672 9.625 17.875V15.25Z",
    fill: "#758BA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.e140d37ec4c9ad4790d7a15d7bbefe8b.svg";
export { ForwardRef as ReactComponent };